import PropTypes from "prop-types";

export function ChartCard({ title, icon: Icon, subtitle, badge, children, className = "" }) {
  return (
    <div className={`chart-card chart-card--animated ${className}`}>
      <div className="chart-card__header">
        <div className="chart-card__header-left">
          {Icon && (
            <span className="chart-card__icon">
              <Icon size={16} />
            </span>
          )}
          <div>
            <span className="chart-card__title">{title}</span>
            {subtitle && <span className="chart-card__subtitle">{subtitle}</span>}
          </div>
        </div>
        {badge && <span className="chart-card__badge">{badge}</span>}
      </div>
      {children}
    </div>
  );
}

ChartCard.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.elementType,
  subtitle: PropTypes.string,
  badge: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default ChartCard;
